import __var_0__ from './main.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Test if a value is an array containing a circular reference.
*
* @module @stdlib/assert/is-circular-array
*
* @example
* var isCircularArray = require( '@stdlib/assert/is-circular-array' );
*
* var arr = [ 1, 2, 3 ];
* arr.push( arr );
*
* var bool = isCircularArray( arr );
* // returns true
*
* bool = isCircularArray( null );
* // returns false
*/

// MODULES //
var isCircularArray = __var_0__;


// EXPORTS //
export default isCircularArray;
